export enum API_COLUMNS_ID {
  Name = 'name',
  Key = 'sk',
  CreatedAt = 'createdAt',
  Action = 'action',
}

export const API_COLUMNS = [
  { id: API_COLUMNS_ID.Name, title: 'Name' },
  { id: API_COLUMNS_ID.Key, title: 'Key' },
  { id: API_COLUMNS_ID.CreatedAt, title: 'Created' },
  { id: API_COLUMNS_ID.Action, title: '' },
];
